module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_wayo-c805941f25a114230c9b283b1539906e.png";